export enum DownloadType {
    CUSTOM_XLSX,
    CUSTOM_CSV,
    MONTHLY_XLSX
}
